import React from 'react'
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';


export const PrivateRoutes = ({

    Autenticado,
    component: Component,
    ...rest // por el rest pasa el path
}) => {

React.useMemo(() =>  {
    if (JSON.parse(localStorage.getItem("log")) && JSON.parse(localStorage.getItem("skll"))){
    localStorage.clear();
    }
},[]);

    return (
        <>
            <Route {...rest}
                component={(props) => (
                    (Autenticado)
                        ? (<Component {...props} />)
                        : (<Redirect to="/login" />)
                )}
            />
        </>
    )
}

//SI O SI LOS NECESITA
PrivateRoutes.propTypes = {
    Autenticado: PropTypes.bool.isRequired,
    component: PropTypes.func.isRequired
}
